import { autoserialize, inheritSerialization } from 'cerialize';

import { AbstractModel } from '@uzurv/core';

@inheritSerialization(AbstractModel)
export class DeactivationReason extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  code: string;

  @autoserialize
  description: string;
}
